import React from 'react';
import Navbar from "components/navBar/Navbar";
import {ToastContainer} from "react-toastify";
import SidebarAdmin from "components/sidebar/sidebarAdmin";
import MediaQuery from "react-responsive";
import EmptyStateCompany from "components/emptyState";

const AdminPageForm = (props) => {
    return (
        <>
            <MediaQuery minWidth={900}>
            <div className="flex h-screen overflow-y-hidden tab:overflow-hidden">
                {/* Sidebar */}
                <SidebarAdmin/>
                {/* Content area */}
                    <div className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden" style={{ scrollbarGutter: 'stable' }}>
                    {/* Navbar */}
                    <Navbar></Navbar>
                    <main>
                            {/* Main Content (pas de gap global: chaque page gère ses marges) */}
                            <div className="flex flex-col w-full h-full bg-white tab:pb-0 pb-20">
                                {props.children}
                            </div>
                    </main>
                </div>
            </div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                limit={2}
                pauseOnFocusLoss
                draggable
            />
            </MediaQuery>
            <MediaQuery maxWidth={899}>
                <EmptyStateCompany type={'desktop'}/>
                <ToastContainer
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    limit={2}
                    pauseOnFocusLoss
                    draggable
                />
            </MediaQuery>
        </>
    );
};

export default AdminPageForm;